import { CSSProperties } from "react";
import Pagination from "../../../../components/Pagination"
import { ProfileMemberColumns } from "../consts/ProfileMemberColumns"
import { ProfileMemberGrid } from "../ProfileMemberGrid"
import { useCommunityMemeberPending } from "../../../../../hooks/manageMembers/useCommunityMemeberPending";
import { CommunityFormEnum } from "../../../../community/enums/CommunityFormEnum";


type Props = {
    titleStyles: CSSProperties;
    userId: number;
    section: CommunityFormEnum;
    onSelect: (u: any) => void;
    reloadKey?: number;
}

export const ProfileMemberPending = ({ titleStyles, userId, section, onSelect, reloadKey }: Props) => {
    const { loading, pending, pendingPage, pendingTotalPages, setPendingPage } = useCommunityMemeberPending(userId, section, reloadKey);

    return (
        <div className="d-flex flex-column" style={{gap: '20px'}}>
            <span style={titleStyles}>
                PENDING
            </span>
            <ProfileMemberGrid
                data={pending}
                loading={loading}
                columns={ProfileMemberColumns}
                onSelect={onSelect}
            />
            {!loading && pending.length === 0 ? (
                <span className="text-center">There is nothing to show for now.</span>
            ): (
                <Pagination currentPage={pendingPage} totalPages={pendingTotalPages} onPageChange={setPendingPage} />
            )}
        </div>
    )
}